import { useCallback } from 'react';
import Modal from './Modal';
import FilePreviewContent from './FilePreviewContent';
import {
  downloadMissionDocumentBlob,
  type MissionApiConfig,
  type MissionDocumentType,
} from '../utils/missionStartApi';

export type MissionDocumentPreviewFile = {
  id: number;
  file_name: string;
  mime_type: string;
  document_type: MissionDocumentType;
};

type MissionDocumentPreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  file: MissionDocumentPreviewFile | null;
  apiConfig: MissionApiConfig;
  missionId: number;
};

const MissionDocumentPreviewModal = ({
  isOpen,
  onClose,
  file,
  apiConfig,
  missionId,
}: MissionDocumentPreviewModalProps) => {
  const downloadFile = useCallback(
    async (_fileId: number): Promise<Blob> => {
      if (file === null) {
        throw new Error('missing file');
      }
      return downloadMissionDocumentBlob(apiConfig, missionId, file.document_type);
    },
    [apiConfig, file, missionId],
  );

  if (file === null) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={file.file_name}
      size="large"
      className="file-preview-modal"
    >
      <FilePreviewContent
        file={{
          id: file.id,
          file_name: file.file_name,
          mime_type: file.mime_type,
          download_url: '',
        }}
        downloadFile={downloadFile}
        isOpen={isOpen}
      />
    </Modal>
  );
};

export default MissionDocumentPreviewModal;
